import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import Logo from "../Assets/Logo.png";
import UseScrollAnimation from "../Elements/ScrollAnimation";

const NotFound = () => {
  UseScrollAnimation(); // ✅ just call it

  const location = useLocation();

  useEffect(() => {
    console.error("404 — Page not found:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="HomeParent">
      <div className="HomeBox ">
        <section className="Disclaimer_Section">
          <div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
            className="Disclaimer_SectionBox01"
          >
            <div className="LogoDiv animate-top">
              <img src={Logo} alt="Logo" className="Logo" loading="eager" />
            </div>
            <p className="Disclaimer_Section_Title animate-top">
              Page not found
            </p>
            <h1 className="Disclaimer_Section_Heading animate-top">404</h1>
            <p className="Disclaimer_Section_Content02 animate-top">
              The page you're looking for has wandered off the path. Let's
              gently guide you back home.
            </p>
            <div className="YourPractitioner_Section_Buttons">
              <Link
                to="/"
                className="YourPractitioner_Section_Button01 animate-top"
              >
                <ArrowLeft className="YourPractitioner_Section_Button01_ArrowRight" />
                <span>Return home</span>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NotFound;
